import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FiLock, FiDelete } from 'react-icons/fi';
import { useWallet } from '../context/WalletContext';
import dexLogo from '../assests/DexWallet Logo Symbol.png';
import '../styles/UnlockPage.css';

const UnlockPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useWallet();
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate('/welcome', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleNumberClick = (number) => {
    if (pin.length < 4) {
      setPin(prev => prev + number);
    }
  };

  const handleDelete = () => {
    if (pin.length > 0) {
      setPin(prev => prev.slice(0, -1));
    }
  };

  const handleUnlock = async () => {
    try {
      setLoading(true);
      setError('');
      // Simulate small delay for better UX feel
      await new Promise(resolve => setTimeout(resolve, 300));

      const storedPin = localStorage.getItem('walletPin');
      if (pin === storedPin) {
        navigate('/loading'); // Or home
      } else {
        setError('Incorrect PIN');
        setPin('');
      }
    } catch (error) {
      setError('Unlock failed');
      setPin('');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (pin.length === 4) {
      handleUnlock();
    }
  }, [pin]);

  return (
    <div className="page-container">
      <div className="aurora-bg">
        <div className="aurora-blob aurora-1" />
        <div className="aurora-blob aurora-3" /> {/* Use 3 for variation */}
        <div className="grid-overlay" />
      </div>

      <motion.div
        className="content-wrapper centered-content"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
      >
        <div className="glass-card unlock-card">
          <div className="logo-section">
            <div className="logo-glow-ring" />
            <img src={dexLogo} alt="DexWallet" className="unlock-logo" />
          </div>

          <div className="unlock-header">
            <h1>Welcome Back</h1>
            <p>Enter your PIN to continue</p>
          </div>

          <div className="pin-display">
            {[...Array(4)].map((_, i) => (
              <motion.div
                key={i}
                className={`pin-dot ${pin.length > i ? 'active' : ''} ${error ? 'error' : ''}`}
                initial={false}
                animate={{
                  scale: pin.length > i ? 1.2 : 1,
                  backgroundColor: pin.length > i ? '#2b5aff' : 'rgba(255,255,255,0.2)'
                }}
              />
            ))}
          </div>

          {error && (
            <motion.p
              className="error-text"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
            >
              {error}
            </motion.p>
          )}

          <div className="keypad-grid">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
              <button
                key={num}
                className="keypad-btn"
                onClick={() => handleNumberClick(num)}
              >
                {num}
              </button>
            ))}
            <div className="keypad-btn empty" />
            <button className="keypad-btn" onClick={() => handleNumberClick(0)}>0</button>
            <button className="keypad-btn delete" onClick={handleDelete}>
              <FiDelete />
            </button>
          </div>

          <div className="forgot-pin">
            <button onClick={() => alert('Reset flow not implemented yet')}>Forgot PIN?</button>
          </div>

        </div>
      </motion.div>
    </div>
  );
};

export default UnlockPage;